/**
 * Special name used for our DP/BookJoin uploaded data.
 */
export const dpProductName = 'Uploaded Data';
